export function setSession(token) {
  localStorage.setItem('token', token);
}

export function getToken() {
  return localStorage.getItem('token');
}

export function parseJwt(token) {
  try { return JSON.parse(atob(token.split('.')[1])); } catch { return null; }
}

export function isLoggedIn() {
  const token = getToken();
  if (!token) return false;
  const payload = parseJwt(token);
  if (!payload?.exp) return false;
  // exp is seconds
  return Date.now() < payload.exp * 1000;
}

export function logout() {
  localStorage.removeItem('token');
}

export async function authFetch(url, options = {}) {
  const token = getToken();
  const headers = { ...(options.headers || {}), Authorization: `Bearer ${token}` };
  const res = await fetch(url, { ...options, headers });
  if (res.status === 401) logout();
  // 402 = valid session but the membership isn't active (lapsed/cancelled past
  // the paid period). Route the user to the subscribe/renew screen. Real
  // enforcement is server-side; this is just UX.
  if (res.status === 402) {
    const payload = token ? parseJwt(token) : null;
    if (payload?.sub && !window.location.pathname.startsWith('/subscribe/')) {
      window.location.href = `/subscribe/${payload.sub}`;
    }
  }
  return res;
}
